import { useAuth } from "../contexts/AuthContext";
import { canRead, canWrite } from "../lib/permissions";

export function usePermissions() {
  const { user } = useAuth();
  return {
    user,
    canRead: (moduleId) => canRead(user, moduleId),
    canWrite: (moduleId) => canWrite(user, moduleId),
  };
}
